import { Login } from './Login';
import { Dashboard } from './Dashboard';
import { DnaReport } from './DnaReport';
import { BloodUpload } from './BloodUpload';
import { BloodResultsDashboard } from './BloodResultsDashboard';
import { Connect } from './Connect';
import { Reports } from './Reports';
import { BloodReport } from './BloodReport';
import { ReferFriend } from './ReferFriend';
import { KitRegistration } from './KitRegistration';
import { Survey } from './Survey';
import { CortisolReportOverview } from './CortisolReportOverview';
import { Icons } from './Icons';
import { Account } from './Account';
import { Verify } from './Verify';
import { StressInsights } from './StressInsights';
import { PostQuizPage } from '../views/PostQuizPage';
import { BloodVitaminInsights } from '../views/BloodVitaminInsights';
import { BloodMineralInsights } from '../views/BloodMineralInsights';
import { DnaInsights } from '../views/DnaInsights';

export default {
  Login,
  Dashboard,
  DnaReport,
  BloodUpload,
  BloodResultsDashboard,
  Connect,
  Account,
  Reports,
  BloodReport,
  ReferFriend,
  KitRegistration,
  Survey,
  CortisolReportOverview,
  Icons,
  Verify,
  StressInsights,
  PostQuizPage,
  BloodVitaminInsights,
  BloodMineralInsights,
  DnaInsights,
};
